<template>
  <div>

    <div class="edit-event-card">

      <div class="tw-text-right tw-mb-4">
        <div v-if="event.status === 'pending'" class="text-1-5">En attente de validation<v-icon class="yellow tw-rounded-full tw-p-2" color="secondary" small right>mdi-clipboard-text-clock</v-icon></div>
        <div v-else class="text-1-5">Publié<v-icon class="green tw-rounded-full tw-p-2" color="white" small right>mdi-check</v-icon> </div>
      </div>

      <div class="tw-w-full text-1-2 tw-mb-12 tw-relative">
        <v-img :aspect-ratio="16/9" :src="event.acf.image_principale.sizes.large" :lazy-src="event.acf.image_principale.sizes.large"/>
      </div>

      <div class="tw-font-bold tw-text-pink">
        {{ event.acf.dates.length }} dates | {{ event.acf.region }}
      </div>
      <h3 class="text-1-8 tw-font-bold">{{ decodeString(event.title.rendered) }}</h3>
      <h4 class="text-1-8">{{ decodeString(event.acf.organisateurs) }}</h4>

      <div class="edit-event-card__actions">
        <div class="tw-h-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-8">
          <v-btn class="btn-shape" :to="'/evenement/'+event.slug" v-if="event.status ==='publish'" color="primary">
            <div class="text-1-5">Voir<v-icon color="white" right>mdi-eye</v-icon></div>
          </v-btn>
          <v-btn class="btn-shape" color="yellow" @click="toEditingPage(event.id)">
            <div class="text-1-5">Éditer<v-icon color="secondary" right>mdi-fountain-pen-tip</v-icon></div>
          </v-btn>
          <v-dialog
              v-model="dialog"
              max-width="325"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="btn-shape" color="secondary"
                     v-bind="attrs"
                     v-on="on">
                <div class="text-1-5">Supprimer<v-icon color="white" right>mdi-delete</v-icon></div>
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="text-h5">
                Confirmer la supression ?
              </v-card-title>
              <v-card-text>Cette action est irréversible, une nouvelle phase de validation sera nécessaire si vous souhaitez recréer cet événement</v-card-text>
              <v-card-actions>
                <v-progress-linear
                    v-if="deleting"
                    class="tw-w-96 tw-mr-4"
                    color="primary accent-4"
                    rounded
                    height="6"
                    indeterminate
                ></v-progress-linear>
                <v-spacer></v-spacer>
                <v-btn
                    color="secondary"
                    text
                    @click="dialog = false"
                >
                  Annuler
                </v-btn>
                <v-btn
                    color="primary darken-1"
                    text
                    @click="deleteEvent"
                >
                  Supprimer
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import store from "../../store";
import he from 'he/he/';

export default {
  name: "EditEvent",
  props : ['event'],
  data () {
    return {
      dialog: false,
      deleting: false,
    }
  },
  methods : {
    decodeString(string) {
      return he.decode(string)
    },
    async deleteEvent() {
      this.deleting = true
      let username = 'wpAppKey'
      let application_password = 'rNM7 k9MU Fak5 ENAv zQ2V 1azQ'
      await axios.delete(store.state.baseJson+'/wp/v2/evenement/'+this.event.id , {
        headers : {
          'Authorization': 'Basic ' + btoa(`${username}` + ":" + `${application_password}`),
        }
      }).then( () => {
        this.deleting = false
        this.dialog = false
        this.$emit('deleted' , this.event.id);
      }).catch( (error) => {
        console.log(error)
      })
    },
    toEditingPage(id) {
      store.commit('setEditingEventID' , id)
      this.$router.push('/modification-evenement')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
